import React from "react";
import { Grid3X3 } from "lucide-react";

const cell = (v) => {
  if (v == null) return "bg-slate-50 text-slate-300";
  if (v >= 80) return "bg-emerald-500 text-white";
  if (v >= 65) return "bg-emerald-200 text-emerald-900";
  if (v >= 50) return "bg-amber-200 text-amber-900";
  if (v >= 35) return "bg-orange-300 text-orange-950";
  return "bg-red-400 text-white";
};

export function SkillHeatmap({ reps, skills, teamSkills }) {
  const scored = reps.filter((r) => Object.keys(r.skills).length);
  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white shadow-[0_4px_20px_-4px_rgba(15,23,42,0.06)] p-5" data-testid="skill-heatmap">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg font-bold tracking-tight text-slate-900 flex items-center gap-2"><Grid3X3 className="w-5 h-5 text-cyan-600" /> Skill heatmap</h2>
        <div className="flex items-center gap-1 text-[10px] font-semibold text-slate-500">
          <span>Low</span>{["bg-red-400", "bg-orange-300", "bg-amber-200", "bg-emerald-200", "bg-emerald-500"].map((c) => <span key={c} className={`w-4 h-3 rounded-sm ${c}`} />)}<span>High</span>
        </div>
      </div>
      {!scored.length ? (
        <p className="mt-4 text-sm text-slate-500" data-testid="heatmap-empty">No scored calls in this period yet. The grid fills in as your reps practise.</p>
      ) : (
        <div className="mt-4 overflow-x-auto -mx-1 px-1">
          <table className="min-w-full border-separate border-spacing-1">
            <thead>
              <tr>
                <th className="text-left text-[10px] font-bold uppercase tracking-wider text-slate-500 pb-1 pr-2 sticky left-0 bg-white">Rep</th>
                {skills.map((s) => <th key={s.key} className="text-[10px] font-bold uppercase tracking-wider text-slate-500 pb-1 px-1 whitespace-nowrap">{s.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {scored.map((r) => (
                <tr key={r.id} data-testid={`heatmap-row-${r.id}`}>
                  <td className="text-sm font-semibold text-slate-900 pr-2 whitespace-nowrap sticky left-0 bg-white">{r.name.split(" ")[0]}</td>
                  {skills.map((s) => {
                    const v = r.skills[s.key];
                    return <td key={s.key} className={`text-center text-xs font-bold rounded-lg h-9 min-w-[56px] ${cell(v)}`} title={`${r.name} · ${s.label}: ${v ?? "—"}`}>{v ?? "·"}</td>;
                  })}
                </tr>
              ))}
              <tr>
                <td className="text-[11px] font-bold uppercase tracking-wider text-slate-500 pr-2 pt-1 sticky left-0 bg-white">Team</td>
                {skills.map((s) => {
                  const t = teamSkills.find((x) => x.key === s.key);
                  return <td key={s.key} className={`text-center text-xs font-extrabold rounded-lg h-9 border-2 border-white ring-1 ring-slate-200 ${cell(t?.avg)}`}>{t?.avg ?? "·"}</td>;
                })}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
